<div class="modal-header justify-content-between">
  <div class="modal-title pull-left d-flex">
    <h4 class="fw-normal m-0">UPDATE NOTE</h4>
  </div>
  <button
    type="button"
    class="btn-close close ms-1"
    aria-label="Close"
    (click)="bsModalRef.hide()"
  >
    <span aria-hidden="true" class="visually-hidden">&times;</span>
  </button>
</div>
<div class="modal-body">
  <div class="row pt-3 border-top">
    <div class="col-12">
      <label>Notes</label>
      <textarea
        class="form-control"
        name="notes-input"
        rows="5"
        [(ngModel)]="activityNote.notes"
      ></textarea>
    </div>
  </div>
</div>
<div class="modal-footer">
  <button
    [disabled]="isSaving || !activityNote.notes"
    type="button"
    class="btn primary-button px-5"
    (click)="updateNote()"
  >
    <i
      *ngIf="isSaving"
      class="fa-duotone fa-spinner-third fa-spin fs-5 me-1"
    ></i>
    Save
  </button>
  <button
    type="button"
    class="btn secondary-button px-5"
    (click)="bsModalRef.hide()"
  >
    Cancel
  </button>
</div>
